(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-removal-packages"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    const choice = event.target.closest('[data-sb-deindex-variant]');
    if (!choice) return;
    const timing = choice.closest('[data-sb-deindex-config]')?.querySelector('[data-sb-deindex-timing]');
    if (timing) timing.value = choice.dataset.sbDeliveryTiming;
  });
  } catch(e) { console.error(e); }
})();

})();
